import { apiDelete, apiGet } from "./apiClient";

async function getCollection(path, errorMessage) {
  const res = await apiGet(path);
  if (!res.ok) return { ok: false, error: res.error ?? errorMessage, items: [] };
  return { ok: true, items: Array.isArray(res.data) ? res.data : [] };
}

export function fetchProductVarientsList() {
  return getCollection("/api/ProductVarients", "Failed to load product varients");
}

export function deleteProductVarient(id) {
  return apiDelete(`/api/ProductVarients/${id}`);
}

export function fetchProductVarientOptionsList() {
  return getCollection("/api/ProductVarientOptions", "Failed to load product varient options");
}

export function deleteProductVarientOption(id) {
  return apiDelete(`/api/ProductVarientOptions/${id}`);
}

export function fetchProductImagesList() {
  return getCollection("/api/ProductImages", "Failed to load product images");
}

export function deleteProductImage(id) {
  return apiDelete(`/api/ProductImages/${id}`);
}

export function fetchProductTagsList() {
  return getCollection("/api/ProductTags", "Failed to load product tags");
}

export function deleteProductTag(id) {
  return apiDelete(`/api/ProductTags/${id}`);
}

export function fetchProductSpecificationsList() {
  return getCollection("/api/ProductSpecifications", "Failed to load product specifications");
}

export function deleteProductSpecification(id) {
  return apiDelete(`/api/ProductSpecifications/${id}`);
}

export function fetchProductQuestionsList() {
  return getCollection("/api/ProductQuestions", "Failed to load product questions");
}

export function deleteProductQuestion(id) {
  return apiDelete(`/api/ProductQuestions/${id}`);
}

export function fetchProductReviewsList() {
  return getCollection("/api/ProductReviews", "Failed to load product reviews");
}

export function deleteProductReview(id) {
  return apiDelete(`/api/ProductReviews/${id}`);
}

export function fetchProductReviewImagesList() {
  return getCollection("/api/ProductReviewImages", "Failed to load review images");
}

export function deleteProductReviewImage(id) {
  return apiDelete(`/api/ProductReviewImages/${id}`);
}
